import request from '../config/network/requestUcenterApiService'

// 练习管理
export function getPracticeList ({
  clients_id,
  title,
  status,
  created_at,
  create_name,
  page = 1,
  per_page = 10
} = {}) {
  let url = 'api/courseware/exercise-customize'

  created_at && (url += `?between[created_at][]=${created_at[0]}&between[created_at][]=${created_at[1]}`)

  return request({
    url,
    method: 'get',
    params: {
      clients_id,
      'like[title]': title,
      'like[create_name]': create_name,
      'equal[status]': status,
      'order[created_at]': 'desc',
      page,
      per_page
    }
  })
}

// 自定义练习创建 - 选择班级
export function getPracticeClass ({
  clients_id,
  number = '',
  page = 1,
  per_page = 10
} = {}) {
  return request({
    url: 'api/student/select-class',
    method: 'get',
    params: {
      clients_id,
      'like[number]': number,
      page,
      per_page
    }
  })
}

// 自定义练习创建 - 添加 (post)
// 练习管理 - 删除 (delete)
// 练习管理 > 详情 (get)
// 练习管理 > 详情 - 修改 (put)
export function getPracticeItem ({
  clients_id,
  title,
  score,
  score_type,
  position,
  publish_time,
  submit_time,
  claim,
  question,
  status,
  id,
  method
} = {}) {
  let url = 'api/courseware/exercise-customize'

  if (id) {
    url += `/${id}`
    !method && (method = 'get')
  } else {
    method = 'post'
  }

  return request({
    url,
    method,
    data: {
      clients_id,
      title,
      score,
      score_type,
      position,
      publish_time,
      submit_time,
      claim,
      question,
      status
    }
  })
}

// 练习管理 > 详情 - 完成情况
export function getPracticeCase ({
  clients_id,
  classes_id,
  customize_id,
  status,
  page = 1,
  per_page = 10
} = {}) {
  return request({
    url: 'api/courseware/class-list',
    method: 'get',
    params: {
      clients_id,
      classes_id,
      customize_id,
      status,
      page,
      per_page
    }
  })
}

// 练习管理 > 详情 > 批注/学生详情 (get)
// 练习管理 > 详情 > 批注详情 - 修改 (put)
export function getPracticeStudent ({
  id,
  score,
  comment,
  status,
  customize_id,
  method = 'get'
} = {}) {
  return request({
    url: `api/courseware/exercise-customize-answer/${id}`,
    method,
    data: {
      score,
      comment,
      status
    },
    params: {
      customize_id
    }
  })
}

// 练习管理 - 复制
export function getPracticeCopy ({
  id
} = {}) {
  return request({
    url: `api/courseware/exercise-customize-copy/${id}`,
    method: 'post'
  })
}

// 评语 - 列表
export function getPracticePiyu ({
  name,
  status,
  created_at,
  clients_id,
  page = 1,
  per_page = 10
} = {}) {
  let url = 'api/courseware/comment-list'

  created_at && (url += `?between[created_at][]=${created_at[0]}&between[created_at][]=${created_at[1]}`)

  return request({
    url,
    method: 'get',
    params: {
      'equal[name]': name,
      'equal[status]': status,
      'order[created_at]': 'desc',
      clients_id,
      page,
      per_page
    }
  })
}

// 评语 - 修改 (put)
// 评语 - 删除 (delete)
export function getPracticePiyuUpdate ({
  id,
  status,
  content,
  method = 'put'
} = {}) {
  return request({
    url: `api/courseware/comment/${id}`,
    method,
    data: {
      status,
      content
    }
  })
}

// 评语 - 添加
export function getPracticePiyuAdd ({
  clients_id,
  content
} = {}) {
  return request({
    url: 'api/courseware/comment',
    method: 'post',
    data: {
      clients_id,
      content
    }
  })
}

// 游戏练习
export function getPracticeGame ({
  clients_id,
  created_at,
  name,
  page = 1,
  per_page = 10
} = {}) {
  return request({
    url: 'api/courseware/exercise-game-list',
    method: 'get',
    params: {
      clients_id,
      created_at,
      'like[name]': name,
      'order[updated_at]': 'desc',
      page,
      per_page
    }
  })
}

// 游戏练习 - 添加
export function getPracticeGameAdd ({
  clients_id
} = {}) {
  return request({
    url: 'api/courseware/exercise-game',
    method: 'post',
    data: {
      clients_id
    }
  })
}

// 游戏练习 - 删除
export function getPracticeGameDelete ({
  ids
} = {}) {
  return request({
    url: 'api/courseware/exercise-game-delete',
    method: 'delete',
    data: {
      ids
    }
  })
}

// 游戏练习 - 查看
export function getPracticeGameDetail ({
  id,
  clients_id,
  config_type
} = {}) {
  return request({
    url: `api/courseware/exercise-game/${id}`,
    method: 'get',
    params: {
      clients_id,
      config_type
    }
  })
}

// 游戏练习 - 查看 发布记录
export function getPracticeGameDetailRecord ({
  id
} = {}) {
  return request({
    url: `api/courseware/exercise-game-packet-list/${id}`,
    method: 'get'
  })
}

// 游戏练习 - 布置练习
export function getPracticeGameTask ({
  domainApi,
  name,
  status,
  number,
  teacher,
  page = 1,
  per_page = 10
} = {}) {
  return request({
    url: `${domainApi}classes`,
    method: 'get',
    params: {
      'like[name]': name,
      'like[number]': number,
      'like[teacher_name]': teacher,
      'equal[teaching_status]': status,
      'order[id]': 'desc',
      'gt[student_count]': 0,
      is_show_student_list: 1,
      page,
      per_page
    }
  })
}

// 游戏练习 - 布置练习 查看 班级详情
export function getPracticeGameTaskClass ({
  domainApi,
  id
} = {}) {
  return request({
    url: `${domainApi}classes/${id}`,
    method: 'get'
  })
}
// 游戏练习 - 布置练习 查看 班级学生
export function getPracticeGameTaskStudent ({
  domainApi,
  id,
  page = 1,
  per_page = 10
} = {}) {
  return request({
    url: `${domainApi}classes/student_list/${id}`,
    method: 'get',
    params: {
      page,
      per_page
    }
  })
}
// 游戏练习 - 布置练习 上课记录
export function getPracticeGameTaskRecord ({
  domainApi,
  id,
  page = 1,
  per_page = 10
} = {}) {
  return request({
    url: `${domainApi}liveroom/log/classes/${id}`,
    method: 'get',
    params: {
      'order[id]': 'desc',
      is_show_teacher: 1,
      page,
      per_page
    }
  })
}

// 游戏练习 - 布置练习 修改班级状态
export function getPracticeGameTaskSwitch ({
  id,
  domainApi,
  teaching_status
} = {}) {
  return request({
    url: `${domainApi}classes/${id}/teaching_status`,
    method: 'patch',
    data: {
      teaching_status
    }
  })
}

// 游戏练习 - 布置练习 选择老师
export function getPracticeGameTeacher ({
  domainApi,
  name,
  mobile,
  page = 1,
  per_page = 10
} = {}) {
  return request({
    url: `${domainApi}staff`,
    method: 'get',
    params: {
      'like[name]': name,
      'like[mobile]': mobile,
      'order[id]': 'desc',
      role_code: 'TE',
      page,
      per_page
    }
  })
}

// 游戏练习 - 布置练习 选择学生
export function getPracticeGameStudent ({
  domainApi,
  name,
  mobile,
  page = 1,
  per_page = 10
} = {}) {
  return request({
    url: `${domainApi}student`,
    method: 'get',
    params: {
      'like[name]': name,
      'like[mobile]': mobile,
      'order[id]': 'desc',
      page,
      per_page
    }
  })
}

// 游戏练习 - 布置练习 选择学生 添加
export function getPracticeGameStudentAdd ({
  domainApi,
  student_list
} = {}) {
  return request({
    url: `${domainApi}student/batch-store`,
    method: 'post',
    data: {
      student_list
    }
  })
}

// 游戏练习 - 布置练习 创建班级
export function getPracticeGameClassCreate ({
  url,
  method,
  name,
  is_update_student,
  student_list,
  student_ids,
  tag_remark,
  teacher_id,
  teacher_name
} = {}) {
  return request({
    url,
    method,
    data: {
      name,
      is_update_student,
      student_list,
      student_ids,
      tag_remark,
      teacher_id,
      teacher_name
    }
  })
}

// 游戏练习 - 布置练习 创建班级 (加入班级)
export function getPracticeGameClassJoin ({
  domainApi,
  classes_id,
  student_list
} = {}) {
  return request({
    url: `${domainApi}student/join-classes`,
    method: 'post',
    data: {
      classes_id,
      student_list
    }
  })
}

// 游戏练习 - 布置练习 确认发布作业
export function getPracticeGameTaskSubmit ({
  game_ids,
  class_ids,
  clients_id
} = {}) {
  return request({
    url: 'api/courseware/exercise-game-layout-work',
    method: 'post',
    data: {
      game_ids,
      class_ids,
      clients_id
    }
  })
}

// 游戏练习 - 复制
export function getPracticeGameCopy ({
  id
} = {}) {
  return request({
    url: 'api/courseware/exercise-game-copy',
    method: 'post',
    data: {
      id
    }
  })
}

// 游戏练习 - 二维码 详情
export function getPracticeGameCode ({
  id
} = {}) {
  return request({
    url: `api/courseware/exercise-game-share/${id}`,
    method: 'get'
  })
}

// 游戏练习 - 二维码 保存
export function getPracticeGameCodeSave ({
  game_id,
  name,
  slogan,
  clients_name,
  address,
  mobile
} = {}) {
  return request({
    url: 'api/courseware/exercise-game-share',
    method: 'post',
    data: {
      game_id,
      name,
      slogan,
      clients_name,
      address,
      mobile
    }
  })
}

// 游戏练习 - 二维码 验证码
export function getPracticeGameCodeCheck ({
  mobile
} = {}) {
  return request({
    url: 'api/verificationCodes/mobile',
    method: 'post',
    data: {
      mobile,
      action: 'login'
    }
  })
}

// 游戏练习 - 二维码 登录
export function getPracticeGameCodeLogin ({
  verification_code,
  verification_key
} = {}) {
  return request({
    url: 'api/oauth/token-mobile',
    method: 'post',
    data: {
      verification_code,
      verification_key
    }
  })
}

// 游戏练习 - 二维码 跳转游戏页面
export function getPracticeGameCocos () {
  return request({
    url: 'api/app-packet/cocos/last',
    method: 'get'
  })
}

// 课件管理 - 课件绑定列表
export function getCourseBindList ({
  id,
  model
} = {}) {
  return request({
    url: 'api/courseware/result-exercise',
    method: 'get',
    params: {
      id,
      model
    }
  })
}

// 课件管理 - 课件绑定
export function getCourseOnBind ({
  id,
  clients_id,
  bind_model,
  bind_id
} = {}) {
  return request({
    url: `api/courseware/result/bind/${id}`,
    method: 'post',
    data: {
      clients_id,
      bind_model,
      bind_id
    }
  })
}

// 课件管理 - 课件解绑
export function getCourseOffBind ({
  source,
  result_id,
  resources_id
} = {}) {
  return request({
    url: 'api/courseware/result/unset-bind',
    method: 'post',
    data: {
      source,
      result_id,
      resources_id
    }
  })
}
